import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, delay, filter, map, shareReplay, startWith, take, tap } from 'rxjs/operators';
import { BehaviorSubject, forkJoin, Observable, of, Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
// Allianz AEM
import {
  EmbeddedDataModule,
  EmbeddedDataService,
  NORMALIZE_URL_SERVICE_CONFIG_TOKEN,
  NormalizeUrlModule,
  NormalizeUrlService
} from '@allianz/ngx-aem-integration'
import { FormService } from './form.service';

interface IXOptions {
  stepIndex: number;
  progress: number;
  footerContent?: string;
  leftButtonsList?: [];
  rightButtonsList?: [];
  outlet?: any;
  backArrow?: any;
  formDisabled?: boolean;
  newCar: boolean;
  footerWithPrice: false;
}

const XDefaults: IXOptions = {
  stepIndex: 0,
  progress: 0,
  footerContent: '',
  leftButtonsList: [],
  rightButtonsList: [],
  backArrow: null,
  outlet: null,
  formDisabled: false,
  newCar: false,
  footerWithPrice: false
};

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  BASE_URL = '/api/v1'
  tokenSubject$ = new BehaviorSubject<string | null>(null);
  subj: Subject<any> = new Subject<any>();
  newRegSubj: Subject<any> = new Subject<any>();
  newSubjPerson: Subject<any> = new Subject<any>();
  subjPerson: Subject<any> = new Subject<any>();
  nextClicks: Subject<void> = new Subject<void>();
  loadingStep: any;
  loadingSpinner;
  reloadProposals = false;
  requested;
  newCar;
  additionalInfo$;
  packageTable$;
  selectedItem;
  productProposals$;
  vehicleDamages$;
  personByEGN$;
  companyByEIK$;
  insSumsMovable$;
  currency$;
  packages;
  footerWithPrice;
  title = 'Allianz';
  steps = [];
  vehicle;
  stepIndex = 0;
  progress = 0;
  range = Array(101).fill(0).map((x, i) => i / 100); // [0,1,2,3,4]
  backArrow;
  rightButtonsList;
  outlet;
  formDisabled;
  $propertyCategories;
  $cities;
  baseTable$;
  $usage;
  productTypes$;
  bnfBank$;

  vehicleDamagesForPrinting$;
  vehicleRegType$;
  vehicleUsages$;
  vehicleDamagesEnum$;
  beneficiaryInCase$;
  printObjectSource$ = new BehaviorSubject({
    policy: null,
    response: null
  });
  printObject$ = this.printObjectSource$.asObservable();
  calculatePremiums$;
  consentsFlag;

  phoneCodes;
  // private previousUrl: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // public previousUrl$: Observable<any> = this.previousUrl.asObservable();
  token$ = this.tokenSubject$.pipe(
    filter((token) => token !== null),
    take(1)
  );
  urlMpping = [];
  hasCallback;
  private errorPayload$ = new BehaviorSubject<any>(null);
  errorState$ = this.errorPayload$.asObservable();
  previousStepName;
  previousStepNumber;
  sharedUrl: string;
  isOfferFromEmail = false;
  gmapsSelectAddress$ =  new BehaviorSubject<any>(null);
  errorMessageFindAddress$ = new BehaviorSubject<any>(null);
  errorMessageDifferentPostCodeReturned$ = new BehaviorSubject<any>(null);

  isAlreadyLoadedOffer = false;
  loadedFromCP = false;
  selectedTabIndexForWhenUserGoesBackToPage: number;
  increaseLimitTicked: boolean;
  savedGlassMin: any;
  savedMTPLMin: any;

  constructor(public http: HttpClient, private router: Router, public normalizeUrlService: NormalizeUrlService) {
    this.updateEnums(normalizeUrlService);
    const stepNames = ['app.aboutProperty', 'app.offerYou', 'app.aboutOwner', 'app.yourPolicy'];
    let i = -1;
    while (++i < 4) {
      this.steps.push({
        title: `${ stepNames[i] }`,
        index: i,
      });
    }

    this._routeHistory = [];
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this._setURLs(event);
        this.sharedUrl = this._currentUrl;
      });
  }

  public _previousUrl: string;

  get previousUrl(): string {
    return this._previousUrl;
  }

  private _currentUrl: string;
  get currentUrl(): string {
    return this._currentUrl;
  }

  public _routeHistory: string[];

  get routeHistory(): string[] {
    return this._routeHistory;
  }

  public _isCustomerPortal: boolean;

  get isCustomerPortal(): boolean {
    return this._isCustomerPortal;
  }

  public _isAgentWebPage: boolean;

  get isAgentWebPage(): boolean {
    return this._isAgentWebPage;
  }


  get routerHistorySize() {
    return this._routeHistory.length;
  }

  updateEnums(normalizeUrlService) {
    this.loadingSpinner = true;
    this.$propertyCategories = this.http.get('/api/v1/enums/new-policy-data/').pipe(catchError(err => of(err)), shareReplay());
    this.currency$ = this.http.get('/api/v1/enums/currency-config/').pipe(catchError(err => of(err)), shareReplay());
    this.$cities = this.http.get('/api/v1/enums/cities/').pipe(catchError(err => of(err)), shareReplay());
    this.productTypes$ = this.http.get('/api/v1/enums/product-types/').pipe(catchError(err => of(err)), shareReplay());
    this.$usage = this.http.get('/api/v1/enums/usage/').pipe(catchError(err => of(err)), shareReplay());
    const test = this.http.get(`/api/v1/enums/deductible/`).pipe(shareReplay());
    this.additionalInfo$ = test.pipe(startWith(null),
      delay(0)/*,shareReplay()*/);
    this.baseTable$ = this.http.get(`/api/v1/table/base`).pipe(catchError(err => of(err)), shareReplay());
    this.packageTable$ = this.http.get(`/api/v1/table/`).pipe(catchError(err => of(err)), shareReplay());
    this.bnfBank$ = this.http.get('/api/v1/banks/').pipe(catchError(err => of(err)), shareReplay());
    this.packages = this.http.get(`/api/v1/enums/packages/`).pipe(catchError(err => of(err)), shareReplay());
    this.vehicleDamagesEnum$ = this.http.get('/api/v1/enums/vehicle-damages/').pipe(catchError(err => of(err)), shareReplay());
    this.beneficiaryInCase$ = this.http.get('/api/v1/enums/beneficiary-in-case/').pipe(catchError(err => of(err)), shareReplay());


    forkJoin({
      propertyCategories: this.$propertyCategories.pipe(take(1)),
      cities: this.$cities.pipe(take(1)),
      productTypes: this.productTypes$.pipe(take(1)),
      usage: this.$usage.pipe(take(1)),
      additionalInfo: this.additionalInfo$.pipe(take(1)),
      baseTable: this.baseTable$.pipe(take(1)),
      packageTable: this.packageTable$.pipe(take(1)),
      bnfBank: this.bnfBank$.pipe(take(1)),
      currency: this.currency$.pipe(take(1)),
    }).subscribe(
      (result) => {
        this.loadingSpinner = false;
      },
      (error) => {
        this.loadingSpinner = false;
      }
    );
  }

  getPersonByEGN(egn) {
    this.personByEGN$ = this.http
      .get(`/api/v1/person/${ egn }`)
      .pipe(shareReplay());
    return this.personByEGN$;
  }

  getPhoneCodes() {
    if(!this.phoneCodes){
      this.phoneCodes=this.http.get<[]>('/api/v1/enums/international-calling-code').pipe(shareReplay());
    }
    return this.phoneCodes
  }

  sendError(payload) {
    return this.http.post('/api/v1/email/call-me-back', payload);
  }

  getPackageCoveragesTableData() {
    return this.packageTable$;
  }

  updateErrorPayload(error) {
    this.errorPayload$.next(error);
  }

  updatePrintObject(obj) {
    this.printObjectSource$.next(obj);
  }

  setConsentsFlag(flag){
    this.consentsFlag=flag;
  }

  getConsentsFlag() {
    return this.consentsFlag;
  }


  getProductProposals(data, form) {
    let movableData;
    const premiums = this.http.post('/api/v1/calculatePremiums', data)
    this.calculatePremiums$ = premiums.pipe(shareReplay());
    return this.calculatePremiums$;
  }

  setSanpshotData(snapshotData, callback?) {
    Object.assign(this, XDefaults, snapshotData);
    if (callback) {
      this.hasCallback = callback;
    }
    if (this.hasCallback) {
      this.hasCallback();
    }
  }


  private _setURLs(event: NavigationEnd): void {
    const currentUrlIndex = this._routeHistory.indexOf(event.urlAfterRedirects);
    if (event.urlAfterRedirects.indexOf('package-selection?') > -1) {
      this._previousUrl = this._routeHistory[this._routeHistory.length - 1];
    } else if (event.urlAfterRedirects === '/start') {
      this._previousUrl = null;
      this._currentUrl = event.urlAfterRedirects;
      this._routeHistory = [];
      this._routeHistory.push(event.urlAfterRedirects);
    } else if (currentUrlIndex > -1) {
      this._routeHistory.length = currentUrlIndex + 1;
      this._previousUrl = this._routeHistory[currentUrlIndex - 1];
      this._currentUrl = event.urlAfterRedirects;
    } else {
      const tempUrl = this._currentUrl;
      this._previousUrl = tempUrl;
      this._currentUrl = event.urlAfterRedirects;
      this._routeHistory.push(event.urlAfterRedirects);
    }
  }

  sendKpiTrackingData(kpiId: number) {
    const params = new HttpParams().set('id', kpiId);
    return this.http.get(`${this.BASE_URL}/user/step/tracking/notification/kpi`, {params})
  }

  getCurrency(): Observable<any>{
   return this.currency$
  }

  showDoubleVisualizationSums(){
    return this.currency$.pipe(
      map((data:any) => {
        return data.doubleVisualisation
      })
    )
  
  }
  gmapsFindAddresses(payload) {
    return this.http.post(`/api/v1/gmaps/find-addresses`,payload)
  }

  getAgentId(agentID){
    return this.http.get(`${this.BASE_URL}/enums/agent-id?agentCard=` + agentID)
  }
}
